import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { fadeAnimations } from 'src/app/shared/animations/fading.animation';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';
import { FundsPortalService } from 'src/app/core/services/funds-portal.service';
import { LocalStorageService } from 'src/app/core/core.module';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-verify-number',
  templateUrl: './verify-number.component.html',
  styleUrls: ['./verify-number.component.less'],
  animations: [fadeAnimations.default, fadeAnimations.down]
})
export class VerifyNumberComponent implements OnInit {

  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;

  public searchFormGroup!: FormGroup;
  
  public email: string = '';

  constructor(
    public route : ActivatedRoute,
    public fundsPortalService: FundsPortalService,
    public localStorageService: LocalStorageService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.initializeFormGroup();
    this.validateInviteCode();
    
  }

    //#region Form Group Events
    initializeFormGroup(): void {
      this.searchFormGroup = new FormGroup({
        mobileNo: new FormControl ('', [Validators.required,
                                        Validators.pattern("(9)[0-9 ]{9}")])
      });
    }

    //#region service calls
    validateInviteCode(): Promise<any> {
      var body = {
        invite_code: this.localStorageService.get('email_code'),
      }
  
      return new Promise<any>((resolve: any, reject: any) => {
        this.fundsPortalService.validateInviteCode(body)
        .subscribe({
          next: (data:any) =>{
            resolve(data);
            this.email = data['response_data']['email'];
            if(data['response_data']['registration_session']['is_mobile_number_verified'] === true){
              this.router.navigateByUrl(``, { skipLocationChange: false });
            }
            else if(data['response_data']['registration_session']['mobile_number'] !== '' && this.localStorageService.get('isReverify') != '1'){
              this.router.navigateByUrl(`/sign-up/otp`, { skipLocationChange: false });
            }
            else if(data['response_data']['registration_session']['company_user'] !== null || this.localStorageService.get('isReverify') === '1'){
              return;
            }
            else if(data['response_data']['registration_session']['company_user'] === null){
              this.router.navigateByUrl(`/sign-up`, { skipLocationChange: false });
            }
          },
          error: error =>{
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'Validation Failed';
            this.atramModal.bodyText = 'Incorrect Credentials';
            this.atramModal.okButtonText = 'Return';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  // OK
                } else {
                  // Cancel
                }
                this.atramModal.hide();
              });
          }
        })
      });
    }

    proceed(): void {
      var mobileNo = this.searchFormGroup.get('mobileNo');
  
      if (!mobileNo?.valid) {
          mobileNo?.markAsTouched();
          return;
      }
      else{
        this.atramModal.show();
        this.atramModal.size = 'xs';
        this.atramModal.status = 'success';
        this.atramModal.headerText = 'Verify Your Mobile Number';
        this.atramModal.bodyText = 'We will now send an One-Time Password (OTP) to:  </br> </br> <b><p style="font-size:20px;">+63' + this.searchFormGroup.get('mobileNo')?.value + '</p></b>';
        this.atramModal.okButtonText = 'Confirm';
        this.atramModal.showCancelButton = false;
        this.atramModal.showCloseButton = true;
        this.atramModal.confirmationSubject
          .subscribe((confirmation: boolean) => {
            if (confirmation) {
              // OK
              this.submit();
            } else {
              // Cancel
            }
            this.atramModal.hide();
          });
      }
    }

    submit(): Promise<any> {
      let body = {  
        mobile_number: "0"+ this.searchFormGroup.get('mobileNo')?.value,
        invite_code: this.localStorageService.get('email_code')
      }
  

      return new Promise<any>((resolve: any, reject: any) => {
        this.fundsPortalService.postAddMobileNo(body)
        .subscribe({
          next: (data:any) =>{
            resolve(data);
            if (data['response_result'] === '0001'){
              if(this.localStorageService.get('isReverify') !== null){
                this.localStorageService.remove('isReverify');
             }
             this.localStorageService.set('isReverify', '0');
              this.router.navigateByUrl(`/sign-up/otp`, { skipLocationChange: false });
            }
          },
          error: error =>{
            this.atramModal.show();
              this.atramModal.size = 'sm';
              this.atramModal.status = 'error';
              this.atramModal.headerText = 'Verification Failed';
              this.atramModal.bodyText = 'contact number already registered.';
              this.atramModal.okButtonText = 'Go To Sign-in';
              this.atramModal.showCancelButton = false;
              this.atramModal.showCloseButton = false;
              this.atramModal.confirmationSubject
                .subscribe((confirmation: boolean) => {
                  if (confirmation) {
                    this.router.navigateByUrl(``, { skipLocationChange: false });
                    // OK
                  } else {
                    // Cancel
                  }
                  this.atramModal.hide();
                });
              return;
          }
        })
      });
    }
  
    goToSignUp(){
      this.router.navigateByUrl(`/sign-up`, { skipLocationChange: false });
    }
}
